import styled from "styled-components";

const StyledButton = styled.button`
  cursor: pointer;
  width: fit-content;
  /* align-self: flex-end; */
  background: ${(props) => (props.outlined ? "white" : props.color)};
  padding: 12px 32px;
  border: ${(props) => ( "2px solid " + props.color)};
  font-weight: 600;
  color: ${(props) => (props.outlined ? props.color : "#fff")};
  border-radius: 100px;
  transition: 300ms;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  &:hover {
    opacity: 0.8;
  }
`;

export function ButtonIcon({
  text,
  outlined = false,
  color = "var(--secondary-forest-green)",
  icon,
  ...props
}) {
  return (
    <StyledButton outlined={outlined} color={color} {...props}>
      {text}
      {icon}
    </StyledButton>
  );
}
